import { useEffect, useState } from 'react';

type useExternalStylesheetProps = {
  href: string;
  cleanup?: boolean;
  load?: boolean;
};

const useExternalStylesheet = ({ href, cleanup = true, load = true }: useExternalStylesheetProps) => {
  const [loaded, setLoaded] = useState(false);

  const isLoaded = () => setLoaded(true);

  useEffect(() => {
    if (!load) return;
    let link = document.querySelector(`link[href="${href}"]`) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', href);
      link.addEventListener('load', isLoaded);
      document.head.appendChild(link);
    } else {
      setLoaded(true);
    }   

    if (cleanup) {
      return () => {
        link.removeEventListener('load', isLoaded);
        document.head.removeChild(link);
      };
    }
  }, [href, cleanup, load]);
  return [loaded];
};

export default useExternalStylesheet;